module.exports = [{
      plugin: require('../../node_modules/.pnpm/gatsby-plugin-manifest@3.15.0_gatsby@3.15.0_@types+node@20.12.8_babel-eslint@10.1.0_eslint@7._4h7yo7oamzbvndt4tnnmn3u7cy/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"freeCodeCamp","short_name":"fCC","start_url":"/","theme_color":"#0a0a23","background_color":"#fff","display":"minimal-ui","icon":"src/assets/images/square_puck.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6cba562cbd10e31af925a976f3db73f7"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
